import { render, staticRenderFns } from "./ProductSizeDialog.vue?vue&type=template&id=23bd93b8&"
import script from "./ProductSizeDialog.vue?vue&type=script&lang=js&"
export * from "./ProductSizeDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports